import React, { useState } from 'react';
import { PanelShell } from '../ui/PanelShell';
import { SectionTitle } from '../ui/SectionTitle';
import { FieldRow } from '../ui/FieldRow';
import { NumberField } from '../ui/NumberField';
import { PillButton } from '../ui/PillButton';
import { Toggle } from '../ui/Toggle';
type SizePanelProps = {
  onClose: () => void;
};
const base = {
  x: 4.21,
  y: 3.86,
  z: 5.02
};
const axisColor = {
  x: '#d0201b',
  y: '#16a316',
  z: '#0a63c9'
};
export function SizePanel({
  onClose
}: SizePanelProps) {
  const [scale, setScale] = useState(100);
  const [uniform, setUniform] = useState(true);
  const factor = scale / 100;
  return <PanelShell title="Size" onClose={onClose} footer={<>
          <PillButton disabled={scale === 100} onClick={() => setScale(100)} data-id="element-480" data-mp="2ji1744ela18d">
            Reset Size
          </PillButton>
          <PillButton variant="primary" data-id="element-481" data-mp="k8cib1wqgh1q">Apply</PillButton>
        </>} data-id="element-479" data-mp="2eksndzdslp50">
      
      <SectionTitle data-id="element-482" data-mp="p5ur8sar2w9q">Scale</SectionTitle>
      <FieldRow label="Scale" info className="min-h-[31px]" data-id="element-483" data-mp="p3nsk46nyyun">
        <NumberField ariaLabel="Scale" value={scale} onChange={setScale} decimals={0} step={5} min={1} max={2000} unit="%" data-id="element-484" data-mp="p58pg0ggatvo" />
      </FieldRow>
      <FieldRow label="Uniform Scaling" className="min-h-[31px]" data-id="element-485" data-mp="fdl1wan0lwzh">
        <Toggle label="Uniform scaling" checked={uniform} onChange={setUniform} data-id="element-486" data-mp="fe4bn42ihf2f" />
      </FieldRow>
      <SectionTitle data-id="element-487" data-mp="be3rr3wn8bnz">Dimensions</SectionTitle>
      {(Object.keys(base) as (keyof typeof base)[]).map(axis => <FieldRow key={axis} label={axis.toUpperCase()} className="min-h-[31px]" labelClassName="font-bold" data-id="element-488" data-mp="1805s37rr831g">
          <NumberField ariaLabel={`${axis.toUpperCase()} dimension`} value={Number((base[axis] * factor).toFixed(2))} onChange={v => setScale(Math.max(1, Math.round(v / base[axis] * 100)))} unit="mm" data-id="element-489" data-mp="z1ts4f4zzswc" />
        
        </FieldRow>)}
      <p className="pt-[6px] text-[11px] leading-snug text-pf-muted" data-id="element-490" data-mp="3jpzp4x4ecvl5">
        Model fits within the Form 3 build volume <span style={{
        color: axisColor.x
      }} data-id="element-491" data-mp="3evc8tljjr7hn">145</span> × <span style={{
        color: axisColor.y
      }} data-id="element-492" data-mp="3gb6m169f26bu">145</span> ×{' '}
        <span style={{
        color: axisColor.z
      }} data-id="element-493" data-mp="3l9801crzjfgg">185</span> mm.
      </p>
    </PanelShell>;
}